import React from "react";
import * as Image from '../../../Assets/Images'
import './style.css'

const RejectedCard = ({label}) => {
    return (
      <div className="rejected-card">
        <img src={Image.congratulations}/>
        <div>
          <img src={Image.rejected_policy}/>
          <label>{label}</label>
        </div>
      </div>
    )
}

export default RejectedCard